import { useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import { FormattedWorkflowResultsDetailsResponse } from "@idw-types/data/workflow-results-details";
import { IdwTable } from "../../../common/idw-table/idw-table";
import { IdwTableContainer } from "../../../common/idw-table-container/idw-table-container";
import { createColumnHelper, getCoreRowModel, useReactTable } from "@tanstack/react-table";

type UserTransactionsSummaryTableContainerProps = {
    workflowResultsDetails: FormattedWorkflowResultsDetailsResponse;
};

type UserTransactionsSummaryTableDataRow = {
    label: string;
    count: number;
    percent: number;
};

export const UserTransactionsSummaryTableContainer = (props: UserTransactionsSummaryTableContainerProps) => {
    const { workflowResultsDetails } = props;

    const data: Array<UserTransactionsSummaryTableDataRow> = useMemo(() => {
        return [
            {
                label: resources.tables.userTransactionsSummary.rows.totalSessions.label,
                count: workflowResultsDetails.summary.totalSessionCount,
                percent: null
            },
            {
                label: resources.tables.userTransactionsSummary.rows.approved.label,
                count: workflowResultsDetails.summary.approvedSessionCount,
                percent: workflowResultsDetails.summary.approvedSessionPercent
            },
            {
                label: resources.tables.userTransactionsSummary.rows.denied.label,
                count: workflowResultsDetails.summary.deniedSessionCount,
                percent: workflowResultsDetails.summary.deniedSessionPercent
            }
        ];
    }, [workflowResultsDetails]);

    const columnHelper = createColumnHelper<UserTransactionsSummaryTableDataRow>();
    const columns = useMemo(() => ([
        columnHelper.accessor("label", {
            header: ""
        }),
        columnHelper.accessor("count", {
            header: resources.tables.userTransactionsSummary.columns.count.header
        }),
        columnHelper.accessor("percent", {
            header: resources.tables.userTransactionsSummary.columns.percent.header,
            cell: (props) => props.getValue() ? <span>{`${props.getValue()}%`}</span> : null
        })
    ]), [data]);

    const useTableResult = useReactTable({
        columns,
        data,
        filterFns: null,
        sortDescFirst: false,
        getCoreRowModel: getCoreRowModel()
    });

    return (
        <IdwTableContainer>
            <IdwTable
                id="user-transactions-summary"
                useTableResult={useTableResult}
                headerColumnKeyPrefix={"user-transactions-summary"}
            />
        </IdwTableContainer>
    );
};